import { scrollConfig } from '@shared/scroll/scroll.config';

export const scrollToElement = (element: Element | null, scrollOptions?: ScrollToOptions): void => {
    if (!element) {
        return;
    }

    element.scrollIntoView(scrollOptions);

    if (window && window.scrollBy) {
        // Scroll as much as necessary to align the top of `element` at `topOffset`.
        // (Usually, `.top` will be 0, except for cases where the element cannot be scrolled all the
        //  way to the top, because the viewport is larger than the height of the content after the
        //  element.)
        window.scrollBy({
            ...scrollOptions,
            top: element.getBoundingClientRect().top - scrollConfig.globalScrollYOffset
        });
    }
};

export const scrollElementIntoView = (element: HTMLElement | null, scrollOptions?: ScrollIntoViewOptions): void => {
    if (!element) {
        return;
    }

    if ('scrollBehavior' in document.documentElement.style) {
        element.scrollIntoView(scrollOptions);
    } else {
        element.scrollIntoView();
    }
};
